import {Component, Input} from "@angular/core";

@Component({
  selector: 'app-onboarding-header',
  templateUrl: './onboarding-header.component.html',
  styleUrls: ['./onboarding-header.component.scss']
})
export class OnboardingHeaderComponent {

  private _title: string = "";
  private _subtitle: string = "";
  private _content: string = "";
  private _isStepperTitle: boolean = false;

  get title(): string {
    return this._title;
  }

  @Input({required: true})
  set title(value: string) {
    this._title = value;
  }

  get subtitle(): string {
    return this._subtitle;
  }

  @Input()
  set subtitle(value: string) {
    this._subtitle = value;
  }

  get content(): string {
    return this._content;
  }

  @Input({required: true})
  set content(value: string) {
    this._content = value;
  }

  get isStepperTitle(): boolean {
    return this._isStepperTitle;
  }
  @Input()
  set isStepperTitle(value: boolean) {
    this._isStepperTitle = value;
  }
}
